const root = process.env.H5_API_ROOT;
export default root;


// WEBPACK FOOTER //
// ./src/app/script/api.js